import { PostEditorPostError, PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { severityResolver } from './helpers/severity-resolver';
import { SelectedSocialProfileValue } from '../../../components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { SingularValidator } from './helpers/singular-validator';

type ProfileBaseNames = 'ig' | 'pn' | 'tt';
type ProfileCombinations = ProfileBaseNames | 'igpn' | 'igtt' | 'pntt' | 'igpntt' | '';

const getProfileType = (selectedSocialProfiles: SelectedSocialProfileValue[]): ProfileCombinations => {
  const profileSet = new Set<ProfileBaseNames>();

  selectedSocialProfiles.forEach(profile => {
    if (profile.__typename === 'InstagramSocialProfile') profileSet.add('ig');
    if (profile.__typename === 'PinterestSocialProfile') profileSet.add('pn');
    if (profile.__typename === 'TikTokSocialProfile') profileSet.add('tt');
  });

  return Array.from(profileSet).sort().join('') as ProfileCombinations; // Sort ensures consistent key generation
};
export const mediaRequired = (postGroup: PostGroupsType, severity: ErrorMessageSeverity): PostEditorPostErrors => {
  const { customizeContentPerProfile, profiles } = postGroup;
  let results: PostEditorPostError[] = [];

  if (customizeContentPerProfile) {
    postGroup.posts.forEach(post => {
      const { media, link } = post.content;
      const selectedSocialProfiles = profiles.filter(p => {
        return (
          (p.__typename === 'InstagramSocialProfile' ||
            p.__typename === 'PinterestSocialProfile' ||
            p.__typename === 'TikTokSocialProfile') &&
          p.profileId === post.customizedProfileId
        );
      });
      const cantUseImageFromLink = selectedSocialProfiles.some(p => p.__typename === 'TikTokSocialProfile');
      const profileType = getProfileType(selectedSocialProfiles);

      if (
        selectedSocialProfiles.length &&
        SingularValidator.mediaRequiredInvalid(media, link, !cantUseImageFromLink) &&
        profileType
      ) {
        results = [
          ...results,
          {
            profileId: post.customizedProfileId,
            variationId: null,
            severity: severityResolver(post, severity),
            selectedSocialProfiles,
            message: PostEditorValidationMessages.mediaRequired[profileType]
          }
        ];
      }
    });
    return results.length ? results : false;
  } else {
    const { media, link } = postGroup.groupPostAttributes.content;
    const selectedSocialProfiles = profiles.filter(p => {
      return (
        p.__typename === 'InstagramSocialProfile' ||
        p.__typename === 'PinterestSocialProfile' ||
        p.__typename === 'TikTokSocialProfile'
      );
    });
    const cantUseImageFromLink = selectedSocialProfiles.some(p => p.__typename === 'TikTokSocialProfile');
    const profileType = getProfileType(selectedSocialProfiles);
    return SingularValidator.mediaRequiredInvalid(media, link, !cantUseImageFromLink) && profileType
      ? {
          profileId: null,
          variationId: null,
          severity: severityResolver(postGroup.groupPostAttributes, severity),
          selectedSocialProfiles,
          message: PostEditorValidationMessages.mediaRequired[profileType]
        }
      : false;
  }
};
